import { useState, useCallback } from 'react';

export function useLocalStorage(key, defaultValue) {
  const [value, setValueState] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const setValue = useCallback(newValue => {
    // Ondersteun zowel een directe waarde als de functie-updater-vorm
    // (setValue(prev => ...)). Zonder dit werd bij de functie-vorm de functie
    // zélf naar localStorage geschreven — JSON.stringify(fn) is undefined, dus de
    // key kreeg de string "undefined" en de volgende load gooide bij het parsen.
    setValueState(prev => {
      const resolved = typeof newValue === 'function' ? newValue(prev) : newValue;
      try {
        localStorage.setItem(key, JSON.stringify(resolved));
      } catch {
        /* opslag vol of geblokkeerd — negeer, state is al bijgewerkt */
      }
      return resolved;
    });
  }, [key]);

  return [value, setValue];
}
